import { render, staticRenderFns } from "./baseDynamics.vue?vue&type=template&id=dd79a064&scoped=true&"
import script from "./baseDynamics.vue?vue&type=script&lang=js&"
export * from "./baseDynamics.vue?vue&type=script&lang=js&"
import style0 from "./baseDynamics.vue?vue&type=style&index=0&id=dd79a064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd79a064",
  null
  
)

export default component.exports